exports.shouldUpdateScroll = ({ pathname }) => {
  // 404ページでは必ず先頭へスクロール
  if (pathname === "/404/" || pathname === "/404") {
    // 先頭へスクロールするための座標を返す
    return [0, 0];
  }

  // 先頭と末尾の / を除いてパスを分割
  const segments = pathname.split("/").filter(Boolean);

  // トップページ（/）のスクロールリセットを許可
  if (segments.length === 0) {
    return [0, 0];
  }

  // ルート直下（/xxx/）のスクロールリセットを許可
  if (segments.length === 1) {
    return [0, 0];
  }

  return false;
};

exports.onRouteUpdate = ({ location }) => {
  if (location.pathname === "/404/" || location.pathname === "/404") {
    // Gatsbyの復元処理が終わったあとに強制的にトップへスクロールさせる
    setTimeout(() => {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }, 450)
  }
}
